<template>
  <v-card class="elevation-1 mb-6 rounded-lg mt-0">
    <v-card-title class="pa-7">
      Přehled podobných zákazníků
      <v-spacer></v-spacer>
    </v-card-title>
    <v-card-text>
      <v-data-table
        v-model="customer.selected"
        :headers="userHeadersByRole"
        :items="customer.items"
        :options.sync="customer.options"
        :server-items-length="customer.serverItemsLength"
        :loading="customer.loading"
        item-key="id"
        class="elevation-0"
        show-select
      >
        <template v-slot:item.id="{ item }">
          <router-link
            :to="{
              name: 'customers.detail',
              params: {
                customerId: item.id,
              },
            }"
          >
            {{ item.id }}
          </router-link>
        </template>
        <template v-slot:item.createdAt="{ item }">
          <DateTime :single-line="false" :datetime="item.createdAt" />
        </template>
        <template v-slot:item.phone="{ item }">
          {{ formatPhoneNumber(item.phone) }}
        </template>
        <template v-slot:item.revision.modifiedAt="{ item }">
          <DateTime :datetime="item.revision.modifiedAt" />
        </template>
        <template v-slot:footer>
          <CustomersMergeFooter v-model="customerFooter" :items="customer.items" />
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { setFilters } from '@/components/mixins/setFilters'
import DateTime from '@/components/DateTime'
import { formatPhoneNumber } from '@/components/mixins/formatPhoneNumber'
import CustomersMergeFooter from '@/components/customer/CustomersMergeFooter'

export default {
  name: 'CustomerDuplicates',
  components: {
    CustomersMergeFooter,
    DateTime,
  },
  mixins: [setFilters, formatPhoneNumber],
  data() {
    return {
      customer: {
        selected: [],
        headers: [
          {
            text: 'Datum',
            value: 'createdAt',
            roles: ['ROLE_ADMIN'],
            width: '150px',
          },
          {
            text: 'Id',
            value: 'id',
            roles: ['ROLE_ADMIN'],
            width: '100px',
          },
          {
            text: 'Jméno',
            value: 'name',
            roles: ['ROLE_ADMIN'],
            width: '15%',
          },
          {
            text: 'Příjmení',
            value: 'surname',
            roles: ['ROLE_ADMIN'],
          },
          {
            text: 'Telefon',
            value: 'phone',
            roles: ['ROLE_ADMIN'],
          },
          {
            text: 'E-mail',
            value: 'email',
            roles: ['ROLE_ADMIN'],
          },
        ],
        items: [],
        options: {
          page: 1,
          itemsPerPage: 10,
          sortBy: ['createdAt'],
          sortDesc: [true],
        },
        loading: false,
        serverItemsLength: 0,
      },
      customerFooter: {
        totalElements: 0,
        selectedData: {
          params: {},
          items: [],
        },
      },
      cancel: null,
    }
  },
  computed: {
    ...mapState({
      authorities: (state) => state.auth.user.authorities,
    }),
    userHeadersByRole() {
      return this.customer.headers.filter((e) => e.roles.some((e) => this.authorities.includes(e)))
    },
  },
  watch: {
    'customer.options': {
      handler() {
        this.loadCustomers()
      },
    },
    '$route.query': {
      handler() {
        this.loadCustomers()
      },
    },
    'customer.selected': {
      handler() {
        this.customerFooter.selectedData.items = this.customer.selected
      },
    },
  },
  methods: {
    ...mapActions({
      searchCustomerDuplicates: 'customer/searchCustomerDuplicates',
    }),
    loadCustomers() {
      this.customer.loading = true
      const searchParams = {
        filterParams: this.$route.query,
        options: this.customer.options,
      }
      this.customerFooter.selectedData.params = searchParams
      this.searchCustomerDuplicates({ id: this.$route.params.customerId, params: searchParams })
        .then((response) => {
          this.customerFooter.totalElements = response.data.totalElements
          this.customer.items = response.data.items
          this.customer.serverItemsLength = response.data.totalElements
          this.cancel = null
        })
        .finally(() => {
          this.customer.loading = false
        })
    },
    setFiltersAction(filters) {
      this.customer.options.page = 1
      this.setFilters(filters)
    },
  },
}
</script>
